var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddFolder(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1572_31646)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5 6.16992H12.5L11.09 4.75992C10.71 4.37992 10.2 4.16992 9.67 4.16992H4.5C3.39 4.16992 2.51 5.05992 2.51 6.16992L2.5 18.1699C2.5 19.2799 3.39 20.1699 4.5 20.1699H20.5C21.6 20.1699 22.5 19.2699 22.5 18.1699V8.16992C22.5 7.06992 21.6 6.16992 20.5 6.16992ZM18.5 14.1699H16.5V16.1699C16.5 16.7199 16.05 17.1699 15.5 17.1699C14.95 17.1699 14.5 16.7199 14.5 16.1699V14.1699H12.5C11.95 14.1699 11.5 13.7199 11.5 13.1699C11.5 12.6199 11.95 12.1699 12.5 12.1699H14.5V10.1699C14.5 9.61992 14.95 9.16992 15.5 9.16992C16.05 9.16992 16.5 9.61992 16.5 10.1699V12.1699H18.5C19.05 12.1699 19.5 12.6199 19.5 13.1699C19.5 13.7199 19.05 14.1699 18.5 14.1699Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1572_31646"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5 0.169922)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddFolder);
export default __webpack_public_path__ + "static/media/AddFolder.0e27c2a666c4925721408321a2453c6b.svg";
export { ForwardRef as ReactComponent };